import { Box } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { useEffect, useRef, useCallback, useState } from "react"
import { connect } from "react-redux"

import api from "apis"
import { useIntersection } from "helpers/use-intersection"

export default function withReviews(WrappedComponent) {
  const InternalComponent = (props) => {
    const { styleCode } = props
    const ref = useRef()
    const inViewport = useIntersection(ref, "0px")
    const [loading, setLoading] = useState(true)
    const [reviews, setReviews] = useState(null)
    const cancelled = useRef(false)

    const fetchAndSet = useCallback(async () => {
      if (!cancelled.current && styleCode) {
        let path = `/api/v3/products/${styleCode}/reviews`
        try {
          const result = await api.get(path)

          if (result?.payload) {
            setLoading(false)
            setReviews(result)
          } else {
            throw new Error("Error on fetch reviews")
          }
        } catch (error) {
          console.log(error?.errors?.[0] || error?.message || error)
          setLoading(false)
        }
      }
    }, [styleCode])

    useEffect(() => {
      if (inViewport) {
        fetchAndSet()
      }
    }, [fetchAndSet, inViewport])

    useEffect(() => {
      return () => (cancelled.current = true)
    }, [])

    return (
      <Box ref={ref}>
        <WrappedComponent
          {...props}
          loading={loading}
          ratings={reviews?.payload?.bottomline}
        />
      </Box>
    )
  }

  InternalComponent.propTypes = {
    styleCode: PropTypes.string,
  }

  const mapStateToProps = (state) => {
    return {
      styleCode: state.choices.style_code && state.choices.style_code.value,
    }
  }

  const mapDispatchToProps = () => ({})

  const Component = connect(
    mapStateToProps,
    mapDispatchToProps
  )(InternalComponent)

  return Component
}
